export enum CareAllowanceOptions {
  YES = 1,
  PARTIALLY = 2,
  NO = 3,
}

export interface AgreedActivityShape {
  examples: string[];
  value: string;
}

export interface AgreedActivityCategory {
  companionship: AgreedActivityShape | null;
  domesticHelp: AgreedActivityShape | null;
  label: string;
  value: string;
}

export interface AgreedActivitiesSelection {
  companionship: string[];
  domesticHelp: string[];
}

export interface AgreedActivitiesDistrictStatistic {
  percentageDisplay: string;
  percentageScale: string;
  percentageValue: string;
  targetReached: boolean;
}

export interface AgreedActivitiesHourlyRates {
  companionship: string;
  domesticHelp: string;
}

export interface NeedsAssessmentConfiguration {
  agreedActivities: {
    categories: AgreedActivityCategory[];
    districtStatistic: AgreedActivitiesDistrictStatistic | null;
    hourlyRates: AgreedActivitiesHourlyRates | null;
  };
}

interface NeedsAssessmentData {
  deploymentPlanning: {
    careAllowance: boolean;
    privateAccount: boolean;
    dispositionSelection: 'weekly' | 'biWeekly';
    dispositionHoursWeekly: number;
    dispositionHoursBiWeekly: number;
  };
  freeOfChargeAidRequested: {
    homeEmergencyCall: boolean;
    nursingAdvice: boolean;
  };
  healthInsuranceBenefits: {
    selection: 'EL&VP' | 'withoutVP';
  };
  healthInsuranceInfo: {
    budgetEl: number;
    budgetVp: number;
    registeredCarer: string;
    vpAlreadyBilled: boolean;
  };
  signatureCustomer: string;
  agreedActivities?: AgreedActivitiesSelection;
}

export interface NeedsAssessmentFormData extends NeedsAssessmentData {
  receivingCareAllowance: {
    careService: string;
    // Cannot be only boolean as RadioButtons convert value to string but we send boolean to backend
    qualityAssuranceInterview: 'yes' | 'no';
    qualityAssurancePerson: string;
    value: CareAllowanceOptions;
  };
  requiredServices: {
    bedLinen: boolean;
    cooking: boolean;
    errands: boolean;
    ironing: boolean;
    normalChores: boolean;
    shopping: boolean;
    strolling: boolean;
    windowCleaning: boolean;
  };
  specifics: { animals: string; others: string; smoker: 'yes' | 'no' };
  startDate: Date;
  submit?: string;
}

export interface NeedsAssessmentPostData extends NeedsAssessmentData {
  receivingCareAllowance: {
    careService?: string;
    qualityAssuranceInterview: boolean;
    qualityAssurancePerson?: string;
    value: number;
  };
  requiredServices: {
    label: string;
    value: boolean;
  }[];
  specifics: { animals: string; others: string; smoker: boolean };
  startDate: string;
  teamManagerComment: string;
}
